import { useUnit } from 'effector-react';
import { openModalEvent } from '@nx-frontend/shared/ui/modal';
import { trackLimitBlocksPopup, trackLimitNotesPopup } from '@nx-frontend/shared/analytics';
import { isFromCallPopupEnabled } from '@nx-frontend/shared/popups/from-call-popup';
import { PaywallPopupPayload, PaywallPopupReason, PopupType } from '@nx-frontend/shared/types';

export function useOpenPaywallPopup() {
  const [openModal] = useUnit([openModalEvent]);

  return (payload: PaywallPopupPayload) => {
    let useFromCallUpgrade = false;
    if (typeof window !== 'undefined') {
      if ('on' === window.localStorage.getItem('useFromCallUpgrade')) {
        useFromCallUpgrade = isFromCallPopupEnabled;
      }
    }
    if (useFromCallUpgrade) {
      openModal({
        showCloseButton: false,
        content: PopupType.FROM_CALL,
        modalContainerStyles: 'bg-[#011519] !rounded-[12px]',
        modalGradient: 'linear-gradient(90deg, #001418 4.38%, #002028 59.57%, #001418 99.95%), #011519',
        usePadding: false,
        payload,
        multipopup: false,
      });
    } else {
      openModal({
        content: PopupType.PAYWALL,
        showCloseButton: false,
        isFullScreen: true,
        modalContainerStyles: 'bg-paywall-popup rounded-none',
        payload,
        multipopup: false,
        ...(payload && 'escapeToClose' in payload ? { escapeToClose: payload.escapeToClose } : {}),
      });
      if (payload?.reason) {
        switch (payload.reason) {
          case PaywallPopupReason.NOTES_LIMIT:
            trackLimitNotesPopup();
            break;
          case PaywallPopupReason.BLOCKS_LIMIT:
            trackLimitBlocksPopup();
            break;
        }
      }
    }
  };
}
